import { Gavel } from 'lucide-react';
import type { PKGNode } from '@blueprint/shared';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';

export interface PKGNodeComponentProps {
  data: PKGNode;
  /** PKGV.D2 (#802) — see NodeShellProps.isConnectable. React Flow passes
   * this to every registered node component; forwarded through to
   * NodeShell so the two <Handle> elements reflect the real canvas-level
   * connectability instead of defaulting to always-connectable. */
  isConnectable?: boolean;
}

export function DecisionNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-decision"
      shape="diamond"
      accentColor={colors.primary.DEFAULT}
      icon={Gavel}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      isConnectable={isConnectable}
    />
  );
}
